<template>
    <div>
        <div>
            <v-subheader>
                <div
                    style="
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                    "
                >
                    <h2>{{ title }}</h2>
                    <v-btn
                        v-if="readonly != true"
                        style="margin-top: 10px"
                        class="mx-2"
                        fab
                        dark
                        small
                        color="blue"
                        @click="openDialog()"
                    >
                        <v-icon dark> mdi-plus </v-icon>
                    </v-btn>
                </div>
            </v-subheader>
            <div class="mt-3">
                <v-data-table
                    dense
                    :headers="headers"
                    :items="items"
                    :items-per-page="15"
                    item-key="id"
                    class="elevation-1"
                    :sort-desc="[false]"
                >
                    <template v-slot:item.porcentaje="{ item }">
                        {{ item.porcentaje | decimalComma }}
                    </template>
                    <template v-slot:item.agente.nomina_bruto="{ item }">
                        {{ item.agente.nomina_bruto | format_precio }}
                    </template>

                    <template v-slot:item.total="{ item }">
                        {{ item.total | format_precio }}
                    </template>
                    <template v-slot:item.facturado="{ item }">
                        {{ item.facturado | format_precio }}
                    </template>
                    <template v-slot:item.pagado="{ item }">
                        {{ item.pagado | format_precio }}
                    </template>
                    <template v-slot:item.pendiente="{ item }">
                        {{ (item.total - item.pagado) | format_precio }}
                    </template>
                    <template v-slot:item.debe="{ item }">
                        {{ item.debe | format_precio }}
                    </template>
                    <template v-slot:item.haber="{ item }">
                        {{ item.haber | format_precio }}
                    </template>
                    <template v-slot:item.cuenta="{ item }">
                        {{
                            item.cuenta_contable
                                ? item.cuenta_contable.numero
                                : item.cuenta
                        }}
                    </template>
                    <template v-slot:item.documento="{ item }">
                        <a
                            v-if="item.factura_id != null"
                            :href="`api/pdf-factura/${item.factura_id}`"
                            target="_blank"
                        >
                            <v-icon
                                small
                                class="mr-2"
                                color="red"
                                style="font-size: 25px"
                                title="PDF"
                                >mdi-pdf-box</v-icon
                            >
                        </a>
                        <a
                            v-if="item.factura_entrante_id != null"
                            :href="`api/pdf-factura-entrante/${item.factura_entrante_id}`"
                            target="_blank"
                        >
                            <v-icon
                                small
                                class="mr-2"
                                color="red"
                                style="font-size: 25px"
                                title="PDF"
                                >mdi-pdf-box</v-icon
                            >
                        </a>
                    </template>

                    <template v-slot:item.action="{ item }">
                        <v-icon
                            v-if="noedit == null"
                            @click="openEditDialog(item)"
                            small
                            class="mr-2"
                            color="#1d2735"
                            style="font-size: 25px"
                            title="EDITAR"
                            >mdi-pencil-outline</v-icon
                        >
                        <v-icon
                            @click="openDeleteDialog(item)"
                            small
                            class="mr-2"
                            color="red"
                            style="font-size: 25px"
                            title="BORRAR"
                            >mdi-trash-can</v-icon
                        >
                    </template>

                    <template v-if="customFooter" v-slot:footer.prepend>
                        <tr
                            style="width: 100%"
                            class="d-flex align-items-center"
                        >
                            <td
                                v-for="column in headers"
                                :key="column.value"
                                :style="{ flex: column.width }"
                                style="padding: 10px 15px"
                            >
                                <!-- Verificamos si es la columna "debe" y mostramos su total -->
                                <span v-if="column.value === 'debe'">
                                    <strong>{{
                                        totalDebe | format_precio
                                    }}</strong>
                                </span>

                                <!-- Verificamos si es la columna "haber" y mostramos su total -->
                                <span v-if="column.value === 'haber'">
                                    <strong>{{
                                        totalHaber | format_precio
                                    }}</strong>
                                </span>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </div>
        </div>

        <!--CREATE DIRECCION-->
        <v-dialog v-model="delete_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>

                    <v-btn color="error" large @click="delete_dialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteEstado()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog" :max-width="width != null ? width : '500px'">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Crear/Editar {{ title }}
                </v-card-title>
                <v-card-text style="text-align: center" class="pt-6">
                    <v-form ref="form">
                        <slot></slot>
                    </v-form>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn color="error" large @click="dialog = false"
                        >Cancelar</v-btn
                    >
                    <v-btn
                        v-if="update"
                        color="success"
                        large
                        @click="updateEstado()"
                        >Modificar</v-btn
                    >
                    <v-btn v-else color="success" large @click="createEstado()"
                        >Guardar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: [
        "title",
        "elementos",
        "show",
        "headers",
        "noedit",
        "readonly",
        "width",
        "customFooter",
    ],
    data() {
        return {
            search: "",
            dialog: false,
            delete_dialog: false,
            update: false,
            index: -1,
            items: [],
            id: null,
        };
    },
    created() {
        if (this.elementos != null) {
            this.items = this.elementos;
        }
    },
    watch: {
        elementos: {
            deep: true,
            immediate: true,
            handler: function (val) {
                if (val != null) {
                    //this.items = [];
                    this.items = val;
                }
            },
        },
    },
    methods: {
        closeDialog() {
            this.dialog = false;
            this.delete_dialog = false;
        },
        createEstado() {
            if (!this.$refs.form.validate()) {
                this.$custom_error("Debe llenar los campos requeridos");
                return;
            }
            this.$emit("create");
            this.closeDialog();
        },
        deleteEstado() {
            this.$emit("delete", this.index);
            this.closeDialog();
        },

        updateEstado() {
            if (!this.$refs.form.validate()) {
                this.$custom_error("Debe llenar los campos requeridos");
                return;
            }
            this.$emit("update");
            this.closeDialog();
        },
        openDeleteDialog(item) {
            this.delete_dialog = true;
            this.index = this.elementos.indexOf(item);
        },
        openDialog() {
            this.id = null;
            this.$emit("getEstado", null);

            this.update = false;
            this.dialog = true;
        },

        openEditDialog(item) {
            this.index = this.elementos.indexOf(item);

            this.$emit("getEstado", this.index);
            this.update = true;
            this.dialog = true;
        },
        getIndexOfId(id) {
            for (let i = 0; i < this.elementos.length; i++) {
                if (this.elementos[i].id == id) {
                    this.index = i;
                    break;
                }
            }
        },
    },
    computed: {
        // Computamos el total de la columna 'debe'
        totalDebe() {
            return this.elementos.reduce((total, item) => {
                return total + item.debe;
            }, 0);
        },
        // Computamos el total de la columna 'haber'
        totalHaber() {
            return this.elementos.reduce((total, item) => {
                return total + item.haber;
            }, 0);
        },
    },
};
</script>
